import type { ReactNode } from "react"

import { AppNavbar } from "@/components/app-navbar"
import { BankSyncPopup } from "@/components/bank-sync-popup"
import { ConfirmProvider } from "@/components/confirm-dialog"
import { RulePrompt } from "@/components/payment_matching_rules/rule-prompt"
import { useReadOnlyGuard } from "@/components/read-only-session"
import { RealtimeEvents } from "@/components/realtime-events"
import { Toaster } from "@/components/toaster"
import { TooltipProvider } from "@/components/ui/tooltip"

/** The signed-in app shell: navigation, notifications and dialogs around every page. */
export default function AppLayout({ children }: { children: ReactNode }) {
  useReadOnlyGuard()

  return (
    <TooltipProvider>
      <ConfirmProvider>
        <AppNavbar />
        <Toaster />
        <RealtimeEvents />
        <main className="pt-16">{children}</main>
        <BankSyncPopup />
        <RulePrompt />
      </ConfirmProvider>
    </TooltipProvider>
  )
}
